import React from "react";
import '../../App.css';

export const NotFound=()=>{
    return(
       <div className="notFound">
         <h1>Página No Encontrada</h1>
       </div>
    )
}